import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FinesService } from '../../service/main/fines.service';
import { Fine, Statistics, DateRange } from '../../entity';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import Enums from '../../utils/enums';
import { SelectItem } from 'primeng/api';
import { Calendar } from 'primeng/calendar';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-fines',
    templateUrl: './fines.component.html',
})

export class FinesComponent implements OnInit {
    @ViewChild('rangeCalendar') rangeCalendar: Calendar;
    @ViewChild('finesTable') finesTable: Table;

    fines: Array<Fine> = new Array<Fine>();
    fineStatistics: Array<Statistics> = new Array<Statistics>();

    //#region component state properties
    loadingState = false;
    noRecordsState = true;
    //#endregion

    //#region date picker properties
    initialPickerDate: any;
    bsConfig: Partial<BsDaterangepickerConfig> = {
        rangeInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false
    };
    //#endregion


    //#region pagination properties
    pagedItems: Array<Fine>;
    pager: any = {};
    //#endregion

    //#region primeng
    cols: any[];
    dateRange: DateRange = new DateRange();
    fineStats: SelectItem[];
    rangeDates: Date[];
    //#endregion

    //#region calendar settings
    isFirstSelected = false;
    //#endregion

    constructor(
        private finesService: FinesService
    ) { }

    ngOnInit() {
        this.cols = [
            { field: 'No', header: 'Numar' },
            { field: 'Plate', header: 'Masina' },
            // { field: 'Title', header: 'Contraventie' },
            { field: 'Parking', header: 'Zona' },
            { field: 'ParkingName', header: 'Parcare' },
            { field: 'AuthorName', header: 'Enforcer' },
            { field: 'FineStat', header: 'Stare' },
            { field: 'PvNote', header: 'Proces Verbal' },
            { field: 'CheckDate', header: 'Data verificare' },
            { field: 'Date', header: 'Data amenda' }
        ];

        this.fineStats = [
            { label: 'Toate', value: null },
            { label: 'Verificate', value: 'Verificata' },
            { label: 'Neverificate', value: 'Neverificata' },
            { label: 'Anulate', value: 'Anulata' },
            { label: 'Amendat', value: 'Amendat' }
        ];

        this.refresh();
    }

    refresh(): void {
        if (this.finesService.finesDateRange) {
            const { StartDate, EndDate } = this.finesService.finesDateRange;
            this.getFines(this.finesService.finesDateRange);
            this.rangeDates = [StartDate, EndDate];
        } else {
            this.getFines(new DateRange(new Date(), new Date()));
            this.rangeDates = [new Date(), new Date()];
        }
    }

    getFines(dateRange: DateRange) {
        this.loadingState = true;
        this.noRecordsState = false;
        this.fines = new Array<Fine>();

        this.finesService.getFines(dateRange).subscribe(data => {
            const fines = new Array<Fine>();
            data.forEach(item => {
                const fine = new Fine();
                fine.fromObject(item);

                if (fine.Avatar == null) {
                    fine.Avatar = '../../../assets/placeholder.jpg';
                }

                fine.FineStat = this.getFineStatByID(fine.FineStatID);

                fines.push(fine);
            });
            this.fines = fines;
            this.loadingState = false;

            if (this.fines.length > 0) {
                this.noRecordsState = false;
            } else {
                this.noRecordsState = true;
            }
        }, (err) => {
            this.loadingState = false;
            this.noRecordsState = true;
        });

        this.finesService.getStatistics(dateRange).subscribe(data => {
            const fineStatistics = new Array<Statistics>();
            data.forEach(item => {
                const fineStatistic = new Statistics();
                fineStatistic.fromObject(item);

                fineStatistics.push(fineStatistic);
            });
            this.fineStatistics = fineStatistics;
        });
    }

    clearSessionState(): void {
        sessionStorage.removeItem('fines-table-state');
    }

    //#region Date picker methods
    onDateRangeChanged(event: Date[]) {
        const dateRange = new DateRange(
            event[0],
            event[1],
        );
        dateRange.StartDate.setHours(2);
        dateRange.StartDate.setMinutes(0);
        // Only in development
        dateRange.StartDate.setDate(dateRange.StartDate.getDate() - 1);

        dateRange.EndDate.setHours(25);
        dateRange.EndDate.setMinutes(59);

        // this.dateRange = dateRange;
        this.getFines(dateRange);
    }
    //#endregion

    selectDates(date: Date): void {
        date.setHours(3);

        if (!this.isFirstSelected) {
            this.dateRange.StartDate = date;
            this.isFirstSelected = true;
        } else {
            this.dateRange.EndDate = date;
            this.isFirstSelected = false;
            this.getFines(this.dateRange);
            this.rangeCalendar.overlayVisible = false;
        }

        this.finesTable.first = 1;
    }

    getFineStatByID(fineStatID: number): string {
        switch (fineStatID) {
            case Enums.eFineStat.Issued:
                return 'Neverificata';
            case Enums.eFineStat.Processed:
                return 'Verificata';
            case Enums.eFineStat.Cancelled:
                return 'Anulata';
            case Enums.eFineStat.Fined:
                return 'Amendat';
        }
    }

    getClassByState(fine: Fine): string {
        switch (fine.FineStatID) {
            case Enums.eFineStat.Issued:
                return 'badge-warning';
            case Enums.eFineStat.Processed:
                return 'badge-success';
            case Enums.eFineStat.Cancelled:
                return 'badge-danger';
            case Enums.eFineStat.Fined:
                return 'badge-primary';
        }
    }
}
